// P1 Tarifstruktur — Single Source of Truth fürs Frontend (Anzeige + Empfehlung).
// Preise sind WOCHENPREISE. Abrechnung MONATLICH, 12 Zahlungen im Jahr:
// monatsbeitrag = wochenpreis * 4. Der Faktor 4,0 (statt 52/12 = 4,3333) ist
// bewusst gewählt — rund sechs Ferienwochen im Jahr bleiben beitragsfrei.
// Die plan_id "<tarif>_<laufzeit>" deckt sich
// 1:1 mit dem Backend (PLAN_LOOKUP in memberships.py) — nur diese ID wird beim
// Vertragsabschluss gesendet, den Preis rechnet der Server.

export const BILLING_WEEKS = 4;

export const LAUFZEIT_LABEL = {
  flex: 'Flexibel (ohne Bindung)',
  m6: '6 Monate',
  m12: '12 Monate',
  m24: '24 Monate',
};
// m6 gibt es nur in der Kinderlinie — laufzeitenFuer() blendet fehlende Stufen aus.
// Kinderpreise sind bewusst GERADE (18/15/12 statt ,90): sie werden muendlich als
// Monatsbetrag verkauft (72/60/48), Erwachsenenpreise bleiben auf ,90 (Preisliste).
export const LAUFZEITEN = ['flex', 'm6', 'm12', 'm24'];
export const EMPFOHLENE_LAUFZEIT = 'm24';

export const LINIE_LABEL = {
  erwachsene: 'Erwachsene',
  kinder: 'Kinder & Jugend',
  family: 'Family',
};

// linie: erwachsene | kinder | family
// leistungen: WERT-Bullets — im Kundenfluss IMMER vor dem Preis zeigen
export const TARIFE = [
  // ── ERWACHSENE ──
  { id: 'basic', name: 'P1 Basic Tarif', linie: 'erwachsene', tier: '1x',
    einheiten: '1× Unterricht / Woche',
    leistungen: ['Klassensystem mit festen Zeiten', 'Rotierender Lehrplan & Einstufungen', 'P1 App inklusive'],
    wochenpreis: { flex: 26.90, m12: 21.90, m24: 16.90 } },
  { id: 'performance', name: 'P1 Performance Tarif', linie: 'erwachsene', tier: '2x', empfohlen: true,
    einheiten: '2× Unterricht / Woche',
    leistungen: ['Alles aus Basic', 'Doppelte Trainingsroutine – schnellere Fortschritte'],
    wochenpreis: { flex: 39.90, m12: 31.90, m24: 24.90 } },
  { id: 'performance_plus', name: 'P1 Performance Plus Tarif', linie: 'erwachsene', tier: 'unlimited',
    einheiten: 'Unbegrenzt Unterricht + Gym + Sauna',
    leistungen: ['Alles aus Performance', 'Unbegrenzter Unterricht', 'Freies Gym-Training', 'Sauna-Credits'],
    wochenpreis: { m12: 48.90, m24: 37.90 } },   // kein Flex: Premiumprodukt nur mit Bindung,
  // ── KINDER ──
  { id: 'basic_kids', name: 'P1 Basic Kids Tarif', linie: 'kinder', tier: '1x',
    einheiten: '1× Unterricht / Woche',
    leistungen: ['Altersgerechte Klassen', 'Einstufungen', 'P1 App (auch für Eltern)'],
    wochenpreis: { m6: 18.00, m12: 15.00, m24: 12.00 } },
  { id: 'performance_kids', name: 'P1 Performance Kids Tarif', linie: 'kinder', tier: '2x', empfohlen: true,
    einheiten: '2× Unterricht / Woche',
    leistungen: ['Alles aus Basic Kids', 'Doppelte Routine – sichtbare Fortschritte'],
    wochenpreis: { m6: 23.00, m12: 20.00, m24: 17.00 } },
  // ── SONDERTARIF (Kids Launch Herbst 2026, Entscheidung 15.09.2026) ──
  // P1 Minis 3–5 Jahre: nur 6 Monate, 15,00 €/Woche = 60 €/Monat. KEIN Betreuter
  // Einstieg (auch nicht am Beratungstag), keine Check-Ups, keine Ferien- &
  // Event-Pauschale, kein Geschwister-/Vorauszahler-Rabatt. Nach der Laufzeit
  // monatlich kuendbar; Wechselangebot Basic/Performance Kids (Einstieg dann
  // regulaer 99/49). `sondertarif: true` schaltet die Bausteine ueberall ab.
  { id: 'minis', name: 'P1 Minis', linie: 'kinder', tier: '1x', sondertarif: true,
    einheiten: '1× Unterricht / Woche · 3–5 Jahre (Sondertarif)',
    leistungen: ['Di oder Fr 14:15 – direkt nach der Kita', 'Erste Einheit mit Mama oder Papa auf der Matte', 'Kein Betreuter Einstieg, keine Pauschale'],
    wochenpreis: { m6: 15.00 } },
  // ── FAMILY (1 Erwachsener + 1 Kind) ──
  { id: 'family', name: 'P1 Family Tarif', linie: 'family', tier: 'family', empfohlen: true,
    einheiten: 'Erwachsener (1×) + Kind (1×)',
    leistungen: ['Beide Mitgliedschaften in einer Vereinbarung – günstiger als einzeln', 'P1 App', '4 bzw. 8 Check-Ups inklusive (12/24 Mon.) – frei auf beide verteilbar'],
    wochenpreis: { m12: 34.90, m24: 24.90 } },
];

export const TARIF_BY_ID = Object.fromEntries(TARIFE.map(t => [t.id, t]));

// Sondertarife (z. B. P1 Minis) haben keine Bausteine: kein Einstieg, keine
// Check-Ups, keine Pauschale, keine Rabatte. Ueberall hierueber pruefen.
export const istOhneBausteine = (tarif) => !!tarif?.sondertarif;

// Kinder- und Family-Tarife haben KEINE Flex-Laufzeit (Entscheidung 26.08.2026):
// Kinderkurse werden nur mit Bindung verkauft. Immer diese Helper nutzen statt
// LAUFZEITEN direkt, wenn ein konkreter Tarif gerendert wird.
export const laufzeitenFuer = (tarif) => LAUFZEITEN.filter(lz => tarif?.wochenpreis?.[lz] != null);

// Geschwisterregel: jedes weitere Kind -25% auf den guenstigeren Kindertarif,
// bei jeder Laufzeit ab 12 Monaten (Betreiber 22.10.2026, vorher nur 24 Monate).
// Bei 6 Monaten zahlt jedes Kind voll.
export const GESCHWISTER = { rabatt: 0.25, abMonaten: 12 };
export const laufzeitMonate = (lz) => (/^m\d+$/.test(lz || '') ? parseInt(lz.slice(1), 10) : 0);

// Zweite Einheit als Add-on im Family-Tarif (26.08.2026): Family Plus ist
// gestrichen. Es gibt EINEN Family-Tarif (beide 1x); die zweite Einheit wird
// je Person dazugebucht — zu den Bausteinpreisen, die ueberall gelten.
// Beispiel 24M: Kind 2x, Elternteil 1x = 24,90 + 5,00 = 29,90 €/Wo = 119,60 €/Monat.
export const ZWEITE_EINHEIT = { erwachsene: 8.00, kinder: 5.00 }; // €/Woche

// Gym & Sauna als Add-on zu JEDER Mitgliedschaft (26.08.2026).
// Baustein-Logik: Performance Plus = Performance + 8,00 (unbegrenzter Unterricht)
// + 5,00 (Gym & Sauna). Das Add-on macht den zweiten Baustein einzeln kaufbar.
// Nur fuer Mitglieder (keine reine Gym-Mitgliedschaft), monatlich zu- und
// abbuchbar, Sauna bleibt bei 4 Credits/Monat.
export const GYM_SAUNA = {
  name: 'Gym & Sauna Add-on',
  wochenpreis: 5.00,            // = 20 € im Monat
  nurMitglieder: true,
  monatlichKuendbar: true,
  saunaCreditsProMonat: 4,
};

// Einmaliger Startbaustein
// Betreuter Einstieg: einmalig — Startbetreuung, Startausstattung, Einstufung,
// App-Einrichtung. Kinder zahlen den Kinder-Satz. Familienregel: je Familie
// werden maximal ZWEI Einstiege berechnet (die beiden teuersten), ab der
// dritten Person ist der Einstieg frei. Family-Vertrag = Erwachsener + Kind.
export const BETREUTER_EINSTIEG = {
  regulaer: 149, tag1: 99,                    // Erwachsene
  kinder: { regulaer: 99, tag1: 49 },
  maxProFamilie: 2,
};

// P1 Check-Up. In JEDER Mitgliedschaft mit Bindung ist ein Kontingent enthalten
// (26.08.2026): 12 Monate -> 4 Check-Ups, 24 Monate -> 8 (Standard, 30 Min) —
// Warenwert 180 bzw. 360 €. Je VEREINBARUNG (bei Family frei auf beide Personen
// verteilbar). Flex und die 6-Monats-Kinderstufe haben kein Kontingent — das ist
// das Upsell-Argument fuer 12 Monate. Zusaetzliche Termine zum Listenpreis.
export const CHECKUP = {
  standard: { minuten: 30, preis: 45 },
  intensiv: { minuten: 60, preis: 75 },
};
export const CHECKUP_INKLUSIVE = { m12: 4, m24: 8 };   // Termine je Vereinbarung

// Ferien- & Event-Pauschale („13. Beitrag"), eingeführt 27.08.2026: einmal
// jährlich zum 1. August wird EIN regulärer Monatsbeitrag zusätzlich fällig
// (Grundtarif inkl. fest gebuchter zweiter Einheit; OHNE Gym & Sauna, das ist
// monatlich kündbar). So kommt die 52-Wochen-Ökonomie zustande: 12 Beiträge
// + 1 Pauschale = 52 × Wochenpreis — deshalb bleibt der Faktor 4,0 unangetastet.
// Nur Laufzeitverträge (m6/m12/m24); Flex zahlt Camps und Seminare einzeln.
// Der Vorauszahler-Rabatt gilt nur auf die 12 Monatsbeiträge, nie auf die Pauschale.
export const FERIEN_EVENT_PAUSCHALE = {
  faelligAm: '1. August',
  nurLaufzeiten: ['m6', 'm12', 'm24'],
  leistungen: {
    erwachsene: ['Open Mat in allen Ferienwochen', 'Alle Seminare kostenfrei'],
    kinder: ['Kostenfreie Teilnahme an den Kindercamps (mehrfach im Jahr, z. B. Kindersommercamp)'],
  },
};

// Vorauszahler: gesamte Laufzeit im Voraus zahlen -> Rabatt auf die Gesamtsumme
export const VORAUSZAHLER = { m12: 0.10, m24: 0.15 };
export const LAUFZEIT_MONATE = { flex: 0, m6: 6, m12: 12, m24: 24 };

export const wochenToVierWochen = (w) => Math.round(w * BILLING_WEEKS * 100) / 100;
export const planId = (tarifId, laufzeit) => `${tarifId}_${laufzeit}`;

// Gesamtsumme der Laufzeit (12 Zahlungen/Jahr) + Vorauszahler-Rabatt
export function vorauszahlerInfo(wochenpreis, laufzeit) {
  const monate = LAUFZEIT_MONATE[laufzeit] || 0;
  const rate = VORAUSZAHLER[laufzeit] || 0;
  if (!monate || !rate) return null;
  const vierWochen = wochenToVierWochen(wochenpreis);
  const gesamt = Math.round(vierWochen * monate * 100) / 100;
  const betrag = Math.round(gesamt * (1 - rate) * 100) / 100;
  const ersparnis = Math.round((gesamt - betrag) * 100) / 100;
  return { rate, prozent: Math.round(rate * 100), gesamt, betrag, ersparnis };
}

export function fmtEuro(v) {
  return `${(v ?? 0).toFixed(2).replace('.', ',')} €`;
}

// ── Empfehlungslogik: Bedarf → genau EIN Tarif ──
// Standard ist IMMER der 2×-Tarif (Performance / Performance Kids / Family).
// Der 1×-Tarif (Basic/Basic Kids) ist nie Erst-Empfehlung, nur bei ausdrücklichem
// 1×-Wunsch (klare Zeit-/Budgetgrenze). Gym/Sauna bzw. "unbegrenzt" -> Plus.
// bedarf: { zielgruppe: 'erwachsener'|'kind'|'familie', frequenz: '1x'|'2x'|'unbegrenzt', gymSauna: bool }
export function empfehleTarif(bedarf = {}) {
  const { zielgruppe, frequenz, gymSauna } = bedarf;
  const will1x = frequenz === '1x';
  const willUnbegrenzt = gymSauna || frequenz === 'unbegrenzt';

  // Family Plus = beide 2×/Woche — bei 2×-Wunsch oder mehr die Plus-Variante
  if (zielgruppe === 'familie') return 'family';   // zweite Einheiten sind Add-ons je Person
  if (zielgruppe === 'kind') return will1x ? 'basic_kids' : 'performance_kids';
  // Erwachsener
  if (willUnbegrenzt) return 'performance_plus';
  return will1x ? 'basic' : 'performance';
}
